import React from 'react';
import "./RadioButton.scss";

const RadioButton = ({ 
  ariaDescribedBy,
  id,
  name,
  value,
  onChange,
  checked,
  label
}) => {
  return (
    <p className="form-radio-item">
      <span className="dragger-item"></span>
      <input
        aria-describedby={ariaDescribedBy}
        type="radio"
        className="form-radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <label id={`label_${id}`} htmlFor={id}>
        {label}
      </label>
    </p>
  );
};

export default RadioButton;